import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { ShipmentHeader } from '../../../models/shipment-header';
import { Observable } from 'rxjs';

export class ShipmentsData implements DataSource<ShipmentHeader> {

    constructor(private source$: Observable<ShipmentHeader[]>) {}

    connect(collectionViewer: CollectionViewer): Observable<ShipmentHeader[]> {
        return this.source$;
    }

    disconnect(collectionViewer: CollectionViewer): void {
    }

}
